function roundToOneDecimal(value) {
  const num = Number(value); // convert string or other type to number
  if (isNaN(num)) return null;
  return parseFloat(num.toFixed(2));
}

export const PercentageDifferenceMarketPrice = (
  psiPrice,
  medianPricePerSqft,
  builtupAareasqft
) => {
  if (
    !psiPrice ||
    !medianPricePerSqft ||
    !builtupAareasqft ||
    builtupAareasqft === "" ||
    builtupAareasqft === "0"
  )
    return { key: "hide-gauge", value: "Hide gauge" };

  let areaSizeSQFt = builtupAareasqft ? parseFloat(builtupAareasqft) : 0;
  const assumedMarketPrice =
    areaSizeSQFt && medianPricePerSqft
      ? Number(medianPricePerSqft * areaSizeSQFt)
      : 0;

  const percentageDifference =
    ((psiPrice - assumedMarketPrice) / assumedMarketPrice) * 100;
  if (percentageDifference > 0)
    return {
      key: "aboveMarketPrice",
      value: "Above Market",
      displayInChart: true,
      percentageDifference: roundToOneDecimal(percentageDifference),
    };
  else if (percentageDifference < 0)
    return {
      key: "belowMarketPrice",
      value: "Below Market",
      displayInChart: true,
      percentageDifference: roundToOneDecimal(percentageDifference),
    };
  else
    return {
      key: "withinRangeMarketPrice",
      value: "Within Range Market Price",
      percentageDifference: roundToOneDecimal(percentageDifference),
    };
};
